// Display copy for the two subscription tiers (same offer as Pornoclaw). The backend only receives `tier`;
// amounts, credits and the cycle come from the deployment env: TIER_1/2, TIER_1/2_CREDITS, SUB_CYCLE_DAYS=7.

export const BILLING = { days: 7, per: 'week', short: '/w', adverb: 'weekly' };

export const PLANS = [
    {
        tier: 1,
        name: 'Starter',
        price: 9.99,
        offerStrike: 19.99, // anchor shown on the in-grid offer card only
        credits: 50,
        summary: '50 photos · 10 videos · HD',
        features: ['50 photo generations', '10 video generations', 'No watermark', 'HD quality'],
    },
    {
        tier: 2,
        name: 'Premium',
        price: 19.99,
        strike: 60,
        credits: 400,
        summary: '400 photos · 20 videos · Priority queue',
        features: ['400 photo generations', '20 video generations', 'Priority queue', 'Full HD quality'],
        badge: 'Most popular · Save 75%',
        popular: true,
    },
];

export const fmtPrice = (n) => `$${Number.isInteger(n) ? n : n.toFixed(2)}`;

export const planByTier = (tier) => PLANS.find((p) => p.tier === tier) || null;
